import React from 'react';
import PropTypes from 'prop-types';

import {connectAppEnv} from '../../../app/app-env';
import {connectModuleEnv} from '../../oe-module-env';
import {withIsOpenState, frefFromRef, frefToRef} from '../../../lib/react/higher-order-components';
import {oeInterfaceManager} from '../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../react-oe/oe-interface-adapter';
import OEAnimateHelper from '../../../lib/animation/oe-animate-helper';
import OEIconCodes from '../../../lib/oe-icon-codes';
import LocalStorage from '../../../lib/tools/local-storage';
import {OEIconButton} from '../../elements/controls/oe-button';
import {OEImplantcastRegisterNoticeControllerUnconnected} from './oe-implantcast-register-notice';

const surveyDoneStorageKey = 'implantcastSurveyNoticeDone';

export class OEImplantcastSurveyNoticeViewUnconnected extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.state = {
            strings: {
                title:          '',
                message:        '',
                buttonLabel:    ''
            },
            link: ''
        };

        this.updateLanguage = this.updateLanguage.bind(this);

        this.onSurveyButtonPressed = this.onSurveyButtonPressed.bind(this);
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.updateLanguage);
    }

    updateLanguage()   {
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                title:          si.getLocalizedStringEnc('implantcast_survey_title'),
                message:        si.getLocalizedStringEnc('implantcast_survey_message'),
                buttonLabel:    si.getLocalizedStringEnc('implantcast_survey_button')
            },
            link:               si.getLocalizedStringEnc('implantcast_survey_link')
        });
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true)   {
            return;
        }

        this.updateLanguage();
    }

    renderView()    {
        let style = {left: this.props.offsets.left, transition: OEAnimateHelper.transitionForInsets(this.props.offsets.animate)};

        if(!this.props.isOpen)  {
            style.visibility = 'hidden';
            style.opacity = '0';
        }

        style.transition = style.transition + (style.transition.length ? ', ' : '') + 'visibility 0.333s ease-in-out, opacity 0.333s ease-in-out';

        return (
            <div className="register-notice-view survey-notice-view" style={style}>

                <div className="register-notice-container">

                    {!this.props.onCloseBtnPressed ? null :
                        <OEIconButton
                            className="transparent-btn close-btn"
                            icon={OEIconCodes.implantcast.registerClose}
                            onPressed={this.props.onCloseBtnPressed}
                        />
                    }

                    <span className="register-notice-msg survey-notice-title">
                        {this.state.strings.title}
                    </span>

                    <span className="survey-notice-msg">
                        {this.state.strings.message}
                    </span>

                    <a className="register-notice-btn" onClick={this.onSurveyButtonPressed}>
                        <span>{this.state.strings.buttonLabel}</span>
                    </a>

                </div>

                <div className="register-notice-spacer"></div>
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                {this.renderView()}
            </React.Fragment>
        );
    }

    onSurveyButtonPressed()    {
        if(typeof(this.state.link) !== 'string' || !this.state.link.length || this.state.link == '#null')  {
            console.log('Warning - no proper link provided to implantcast survey view.');
            return;
        }

        window.open(this.state.link);
        if(this.props.onSurveyBtnPressed)   this.props.onSurveyBtnPressed(this);
    }
}

OEImplantcastSurveyNoticeViewUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEImplantcastSurveyNoticeViewUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool,
    onCloseBtnPressed:          PropTypes.func,
    onSurveyBtnPressed:         PropTypes.func
};

export const OEImplantcastSurveyNoticeView = frefFromRef(connectModuleEnv((env) => {
    return {
        offsets: {
            left:               env.ui.leftSlideInContainer.offset,
            animate:            {left: env.ui.leftSlideInContainer.animate}
        }
    };
})(frefToRef(OEImplantcastSurveyNoticeViewUnconnected)));

//
// opens like the register notice - once the start view and the other blocking views are closed - but for every user,
// whatever the licensing state, and only until the user took the survey or closed the notice in this browser
export class OEImplantcastSurveyNoticeControllerUnconnected extends OEImplantcastRegisterNoticeControllerUnconnected {

    constructor(props) {
        super(props);

        this.onSurveyBtnPressed = this.onSurveyBtnPressed.bind(this);
    }

    shouldOpenLicensing()   {
        return LocalStorage.getItem(surveyDoneStorageKey) !== 'true';
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>

                <OEImplantcastSurveyNoticeView
                    moduleId={this.props.moduleId}
                    isOpen={this.props.isOpen}
                    onCloseBtnPressed={this.onCloseBtnPressed}
                    onSurveyBtnPressed={this.onSurveyBtnPressed}
                />
            </React.Fragment>
        );
    }

    onCloseBtnPressed() {
        LocalStorage.setItem(surveyDoneStorageKey, 'true');
        super.onCloseBtnPressed();
    }

    onSurveyBtnPressed() {
        this.onCloseBtnPressed();
    }
};

OEImplantcastSurveyNoticeControllerUnconnected.defaultProps = {
    moduleId:                   '',
    isOpen:                     true
};

OEImplantcastSurveyNoticeControllerUnconnected.propTypes = {
    moduleId:                   PropTypes.string,
    isOpen:                     PropTypes.bool
};

export const OEImplantcastSurveyNoticeController = withIsOpenState(frefFromRef(connectAppEnv((env) => {
    return {
        appComponent:           env.component
    };
})(frefToRef(OEImplantcastSurveyNoticeControllerUnconnected))));
